import type { ExtensionConfig } from '@goto/shell'
import { getLaunchDarklyFlag } from '../helpers/shell-helpers'
import { LaunchDarklyVariations } from '../models/feature-flag.models'

const canOverrideExperiencePath = (version: string) => version !== 'latest'

const getVoiceExperiencePath = () => {
  const version = getLaunchDarklyFlag(LaunchDarklyVariations.GTC_VOICE_EXPERIENCE_VERSION) ?? 'latest'

  // this string needs to exist on its own for feature branch deployments
  let path = '/experiences/voice/latest'

  if (canOverrideExperiencePath(version)) {
    path = `/experiences/voice/${version}`
  }
  return path
}

const prerequisiteRoles = 'jive || gotoconnect || grasshopper'

/**
 * Extension config
 */
const extensionConfig: ExtensionConfig = {
  id: '@voice',
  get url() {
    const path = getVoiceExperiencePath()
    return new URL(`${path}/extension.js`, window.location.origin)
  },
  dependencies: [],
  prerequisites: {
    roles: prerequisiteRoles,
  },
  unguardedRoutes: [],
  esModule: true,
}

const softphoneUIExtensionConfig: ExtensionConfig = {
  id: '@voice-softphone-ui',
  get url() {
    const path = getVoiceExperiencePath()
    return new URL(`${path}/extension-softphone-ui.js`, window.location.origin)
  },
  // When the UI is loaded in the dedicated softphone window with the
  // standaloneRoutes declared below, only the extensions declared in the
  // dependencies list will be loaded. Even though the UI depend on the
  // call system running either in the jiveweb or voice extension, we don't
  // declare the dependency here because it would reload it in the 2nd window.
  // Instead, the UI interact with the call system running in any window using
  // shell commands and event bus.
  dependencies: [],
  standaloneRoutes: ['^/softphone-ui'],
  unguardedRoutes: [],
  prerequisites: {
    roles: prerequisiteRoles,
  },
  esModule: true,
}

export default { mainExtension: extensionConfig, softphoneUIExtension: softphoneUIExtensionConfig }
